import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppointmentService } from 'src/app/services/appointment.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
interface DialogData {
  business: any;
}
@Component({
  selector: 'app-business-appointment',
  templateUrl: './business-appointment.component.html',
  styleUrls: ['./business-appointment.component.scss']
})
export class BusinessAppointmentComponent implements OnInit {
  faClose = faTimes;
  
  get minDateString(): string {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  bookingForm: FormGroup = this.fb.group({
      appointmentDate: ['', Validators.required],
      appointmentStart: ['', Validators.required],
      clientName: ['', Validators.required],
      clientSurname: ['', Validators.required],
      clientMobile: ['', Validators.required],
      clientEmail: ['', Validators.required],
      additionalNotes: ['']
    });
  makingAppointment = false;
  today = new Date().toLocaleDateString('en-ZA', { weekday: 'long' });  ;
  myDateFilter = (d: Date | null): boolean => {
    const now = new Date();
    now.setHours(0,0,0,0);
    return d > now;
  }
  minDate = new Date();
  constructor(private fb: FormBuilder, private _snackBar: MatSnackBar, private appointmentService: AppointmentService, public dialogRef: MatDialogRef<BusinessAppointmentComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  
  ngOnInit(): void {
    this.bookingForm = this.fb.group({
      appointmentDate: ['', Validators.required],
      appointmentStart: ['', Validators.required],
      clientName: ['', Validators.required],
      clientSurname: ['', Validators.required],
      clientMobile: ['', Validators.required],
      clientEmail: ['', Validators.required],
      additionalNotes: ['']
    });
    console.log(this.data.business)
  }

      makeAppointment(): void {
      if (this.bookingForm?.invalid) return;
      
      this.makingAppointment = true;
      const formVals = this.bookingForm?.value;
      
      const appointment = {
        appointmentType: 'Booking Request',
        appointmentLocation: this.data.business.Address || 'General',
        businessName: this.data.business.Name,
        businessId: this.data.business.id,
        appointmentDate: formVals.appointmentDate.toString(),
        appointmentDuration: '60 min',
        clientName: formVals.clientName,
        clientSurname: formVals.clientSurname,
        clientMobile: formVals.clientMobile,
        clientEmail: formVals.clientEmail,
        additionalNotes: formVals.additionalNotes,
        preferredPractitioner: 'Any Available',
        colorId: 1
      };
  
      this.appointmentService.createAppointmentRequest(appointment).then(() => {
        this._snackBar.open('Appointment request sent successfully', 'OK', { duration: 3000 });
        this.dialogRef.close()
        this.bookingForm?.reset();
        this.makingAppointment = false;
      }).catch((err: any) => {
        console.error(err);
        this._snackBar.open('Failed to send appointment request', 'OK', { duration: 3000 });
        this.makingAppointment = false;
      });
    }
}
